import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component } from '@angular/core';
import { MapHelperService } from 'src/services/map-helper.service';
import { PanelAddGeofencesService } from '../../../services/Panel-Add-Geofences.service';
import { NotificationsToastService } from 'src/app/features/shared/services/Notifications-Toast.service';

@Component({
  selector: 'polygon-selector',
  templateUrl: './polygon-selector.component.html',
  styleUrls: ['./polygon-selector.component.css']
})
export class PolygonSelectorComponent {
  mobileQuery: MediaQueryList;
    private _mobileQueryListener: () => void;
    fullScreen: boolean = false;

    public $guidEditable: string = "";
    public $isDuplicate: boolean = false;
  
    polygonButtonMsg: string = "Selecciona varios puntos en el mapa para crear una figura y para finalizar da doble click sobre el mapa";
    isPolygonButtonMsgVisible : boolean = false;
    polygonFinishMsg: string = "Hacer doble clic para finalizar colocación de vertices y mover la figura.";
    polygonEditButtonMsg: string = "Seleccione el poligono para editarlo. Puede mover la figura o agregar más puntos";
    isPolygonEditButtonMsgVisible : boolean = false;
  
    
    AddPolygonSelected: string = "";
  
    constructor(changeDetectorRef: ChangeDetectorRef, 
      media: MediaMatcher,
      private mapHelperService: MapHelperService,
      private panelAddGeofencesService: PanelAddGeofencesService,
      private notificationToastService: NotificationsToastService) {
      this.mobileQuery = media.matchMedia("(min-width: 760px)");
      this._mobileQueryListener = () => changeDetectorRef.detectChanges();
      this.mobileQuery.addListener(this._mobileQueryListener);

      
      this.$guidEditable = this.panelAddGeofencesService.$guidEditable;
      this.$isDuplicate = this.panelAddGeofencesService.$isDuplicate;
    }

    ngOnInit(): void {
      console.log("ngOnInit polygon-selector");
      
      this.createPolygonPoints(false);
    }

    ngOnDestroy(): void {
      console.log("ngOnDestroy polygon-selector");
      
      this.mapHelperService.removeGeofencePolygonDrawControl();
      this.isPolygonButtonMsgVisible = false;
      this.isPolygonEditButtonMsgVisible = false;
      this.AddPolygonSelected = "";
      this.mapHelperService.UpdateLayerGeoJson("PolygonActiveSource",this.mapHelperService.Empty_GeoJson);
      this.mapHelperService.polygonPoints = [];
    }
  
    createPolygonPoints(isFromButton: boolean){

      if(!this.mapHelperService.drawGeofencePolygon || typeof this.mapHelperService.drawGeofencePolygon.getAll !== 'function'){
        this.mapHelperService.addGeofencePolygonDrawControl();
      }
      var featuresLength = 0;
      try{
        featuresLength = this.mapHelperService.drawGeofencePolygon.getAll().features.length;
      }catch(error){
        this.mapHelperService.addGeofencePolygonDrawControl();
        featuresLength = this.mapHelperService.drawGeofencePolygon.getAll().features.length;
      }
      //checa si ya hay un poligono dibujado, si no, permite crear uno nuevo
      if (featuresLength < 1) {
        this.isPolygonButtonMsgVisible = true;
        //checa si el poligono se está editando, si sí, eliminar el poligono y permitir crear uno nuevo
        //si está creando uno nuevo, no permite crear otro hasta que se elimine el que ya está creado
        if (this.$guidEditable != "") {
          console.log("editando poligono si guid", this.mapHelperService.drawGeofencePolygon.getAll().features, this.$guidEditable);
          this.mapHelperService.drawGeofencePolygon.deleteAll();
          this.mapHelperService.drawGeofencePolygon.changeMode('draw_polygon');
          this.AddPolygonSelected = "create";
        }else{
          console.log("editando poligono no guid", this.mapHelperService.drawGeofencePolygon.getAll().features, this.$guidEditable);
          this.mapHelperService.drawGeofencePolygon.changeMode('draw_polygon');
          this.AddPolygonSelected = "create";
        }
      }
      else{
        console.log("editando poligono", this.mapHelperService.drawGeofencePolygon.getAll().features, this.mapHelperService.drawGeofencePolygon.getAll());
        if(isFromButton)
          this.notificationToastService.showError("Ya se ha creado un polígono","Error al Crear Polígono");
      }
    }

    editPolygonPoints(){
    //checa si ya hay un poligono dibujado, si no, manda mensaje de error, si sí, permite editar los vertices
    if (this.mapHelperService.drawGeofencePolygon.getAll().features != null && this.mapHelperService.drawGeofencePolygon.getAll().features.length > 0) {
      const lastFeatureId = this.mapHelperService.drawGeofencePolygon.getAll().features[0] != null ? this.mapHelperService.drawGeofencePolygon.getAll().features[0].id.toString() : null; 
      this.mapHelperService.drawGeofencePolygon.changeMode('direct_select' , { featureId: lastFeatureId });
      this.isPolygonEditButtonMsgVisible = true;
      this.AddPolygonSelected = "edit";
      this.fullScreen = false;
    }else{
      this.notificationToastService.showError("No se ha creado un polígono","Error al Editar Polígono");
    }
  }

  //boton de eliminar vertices
  deletePolygonPoints(){
      this.mapHelperService.drawGeofencePolygon.deleteAll();
      this.mapHelperService.updatePolygonArea('draw.delete');
      this.AddPolygonSelected = "";
  }

  onVisibilityChange(isVisible: boolean) {
    this.isPolygonButtonMsgVisible = isVisible;
    this.isPolygonEditButtonMsgVisible = isVisible;
  }
}
